import { NinetailedInsightsPlugin } from "@ninetailed/experience.js-plugin-insights";

// Sends component view/click events to Ninetailed. Without it the dashboard reports
// "Estimated profiles, but no component views" for every experience, because nothing
// else reports exposures back to Ninetailed (VariantViewedTracker only feeds Segment).
// Module scope for the same reason as ssrPlugin: one instance per page load, so the
// seen-element set and event queue aren't reset by re-renders.
export const insightsPlugin = new NinetailedInsightsPlugin();
